import React from 'react';
import {
  connect,
} from 'react-redux';

import {
  $modalState,
  closeModal,
  okButtonHandler,
  cancelButtonHandler,
} from './PromptModal.duck';

import {
  Modal,
  PrimaryButton,
  SecondaryButton,
} from '../../components';

import css from './PromptModal.module.scss';

const PromptModal = (props) => {
  const {
    contentType,
    modalState,
    onCloseModal,
  } = props;

  const [okButtonInProgress, setOkButtonInProgress] = React.useState(false);

  const handleCloseModal = () => {
    if (okButtonInProgress) {
      return ;
    }
    onCloseModal();
  };

  const handleOkButtonClick = () => {
    if (okButtonHandler) {
      const handler = okButtonHandler();
      if (handler instanceof Promise) {
        setOkButtonInProgress(true);
        handler
          .then(resp => {
            setOkButtonInProgress(false);
            return resp;
          })
          .catch(e => {
            setOkButtonInProgress(false)
            throw e;
          })
        ;
      }
    }
  };

  const handleCancelButtonClick = () => {
    if (cancelButtonHandler) {
      cancelButtonHandler();
    }
    handleCloseModal();
  };

  return (
    <Modal
      id="PromptModal"
      isOpen={modalState.isOpen}
      onClose={handleCloseModal}
      usePortal={false}
      onManageDisableScrolling={() => {}}
    >
      <p className={css.text}>
        {modalState.options.text}
      </p>

      <div className={css.buttons}>
        <PrimaryButton
          inProgress={okButtonInProgress}
          disabled={okButtonInProgress}
          onClick={handleOkButtonClick}
        >
          {modalState.options.okButtonText}
        </PrimaryButton>
        <SecondaryButton
          disabled={okButtonInProgress}
          onClick={handleCancelButtonClick}
        >
          {modalState.options.cancelButtonText}
        </SecondaryButton>
      </div>
    </Modal>
  );
};

const mapStateToProps = state => {
  return {
    modalState: $modalState(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onCloseModal: () => dispatch(closeModal()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PromptModal);
